import React from "react";

const steps = [
  { label: "Route", icon: "fa-map-marker-alt" },
  { label: "Load Details", icon: "fa-box-open" },
  { label: "Review & Pay", icon: "fa-credit-card" },
];

export default function QuoteProgress({ activeStep }) {
  return (
    <div className="quote-progress" aria-label="Booking progress">
      {steps.map((step, index) => {
        const stepNumber = index + 1;
        const state =
          stepNumber < activeStep
            ? "is-complete"
            : stepNumber === activeStep
              ? "is-active"
              : "";

        return (
          <div className={`quote-progress-step ${state}`} key={step.label}>
            <span className="quote-progress-icon" aria-hidden="true">
              <i
                className={`fa ${
                  stepNumber < activeStep ? "fa-check" : step.icon
                }`}
              ></i>
            </span>
            <span className="quote-progress-copy">
              <small>Step {stepNumber}</small>
              <strong>{step.label}</strong>
            </span>
          </div>
        );
      })}
    </div>
  );
}
